import type { Grenade } from "@69ly/shared";
import { GRENADE_ICONS } from "@69ly/ui/grenade-icons";

const ICON = { smoke: "smoke", flash: "flash", molotov: "molotov", he: "he" } as const;

/**
 * Counter-Strike 2's own grenade silhouette, in the grenade's colour: the same
 * shape and colour everywhere. Without `size`, CSS decides (markers on the map).
 */
export function GrenadeGlyph({ grenade, size }: { grenade: Grenade; size?: number }) {
  const icon = GRENADE_ICONS[ICON[grenade]];
  // The silhouettes are tall and thin: a bit more room than the old shapes keeps them readable.
  const px = size ? Math.round(size * 1.35) : undefined;
  return (
    <svg
      className={`gicon gicon-${grenade}`}
      viewBox={icon.viewBox}
      width={px}
      height={px}
      aria-hidden="true"
      focusable="false"
      // Static, bundled SVG paths: no user content.
      dangerouslySetInnerHTML={{ __html: icon.body }}
    />
  );
}
